import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthLayout, DashboardLayout } from 'shared/layouts';
import { AuthPage } from 'pages/auth/Auth';
import { UsersMPPage } from 'pages/users/UsersMPPage';
import { UserMPPage } from 'pages/users/UserMP';
import { useSelector } from 'react-redux';
import { MechanicPage } from 'pages/promo/MechanicPage/MechanicPage';
import { MechanicDetailPage } from 'pages/promo/MechanicPage/MechanicDetailPage';
import { RootState } from 'app/store';
import { GrantedRoute } from 'shared/helpers/GrantedRoute';
import { DistributionPage } from 'pages/users/DistributionPage';
import { PromoB2BPage } from 'pages/promo/PromoB2BPage';
import { PromoB2BDetailPage } from 'pages/promo/PromoB2BDetailPage/PromoB2BDetailPage';
import { ShopDotsPage } from 'pages/shopDots/ShopDotsPage';
import { ShopDotsDetailPage } from 'pages/shopDots/ShopDotsDetail/ShopDotsDetailPage';
import { ProductDetailPage } from 'pages/marketplace/product/ProductDetailPage/ProductDetailPage';
import { ProductsPage } from 'pages/marketplace/product/ProductsPage';
import { DistributionsDetailPage } from 'pages/users/DistributionsDetailPage';
import { CategoryPage } from 'pages/marketplace/category/CategoryPage';
import { CountriesPage } from 'pages/settings/CountriesPage';
import { CitiesPage } from 'pages/settings/CitiesPage';
import { PartnerPage } from 'pages/marketplace/partner/PartnerPage';
import { BrandsPage } from 'pages/content/BrandsPage';
import { BrandsDetailPage } from 'pages/content/BrandsDetailPage';
import { BannerTypePage } from 'pages/content/BannerTypePage';
import { StoriesPage } from 'pages/content/StoriesPage';
import { StoriesDetailPage } from 'pages/content/StoriesDetailPage';
import { BannerDetailPage } from 'pages/banners/BannerDetailPage/BannerDetailPage';
import { BonusesStatisticsPage } from 'pages/bonusesStatistics/BonusesStatisticsPage';
import { PrizesPage, PrizesDetailPage } from 'pages/prizes';
import { BonusStatisticsDetailInfo } from 'widgets/bonusesStatistics';
import { FinanceOperationsPage, FinanceOperationsDetailPage } from 'pages/financeOperations';
import { SendOtpPage } from 'pages/sendOTP';
import { BannersPage } from 'pages/banners';
import { ReportPromoPage } from './reportPromo/ReportPromoPage';
import { CompetitionB2BDetailPage } from './competitons-b2b/detail';
import { CompetitionSalePointDetails } from './competitons-b2b/salePoint';
import { DownloadsBonusesPage, DownloadsShopDotsPage, DownloadsTablesCodePage } from './downloads';
import ShopDotsUpdateUsers from './shopDots/shop-dots-update-users';
import ShopDotsUpdateDots from './shopDots/shop-dots-update-dots';
import { PrizePlacesPage } from './competitons-b2b/prize-places';
import { PrizePlacePage } from './competitons-b2b/prize-place';
import { CompetitonsB2BPage } from './competitons-b2b';
import { CompetitonsB2CRPage } from './competitions-b2cr';
import { CompetitionB2CRDetailPage } from './competitions-b2cr/detail';
import { AgreementPage } from 'pages/agreement/AgreementPage';

export const Routing = () => {
  const isLogged = useSelector((state: RootState) => state.auth.isLogged);

  return (
    <Routes>
      <Route
        path="/partner_agreement"
        element={<AgreementPage />}
      />
      <Route
        element={
          <GrantedRoute
            allowed={!isLogged}
            redirect="/users-mp"
          />
        }
      >
        <Route
          path="/auth"
          element={<AuthLayout />}
        >
          <Route
            index
            element={<AuthPage />}
          />
        </Route>
      </Route>
      <Route
        element={
          <GrantedRoute
            allowed={isLogged}
            redirect="/auth"
          />
        }
      >
        <Route
          path="/"
          element={<DashboardLayout />}
        >
          <Route
            path="/users-mp/:app_type"
            element={<UsersMPPage />}
          />
          <Route
            path="/users-mp/:app_type/:id"
            element={<UserMPPage />}
          />
          <Route
            path="/users-mp"
            element={<UsersMPPage />}
          />
          <Route
            path="/users-mp/:id"
            element={<UserMPPage />}
          />
          <Route
            path="/shop-dots"
            element={<ShopDotsPage />}
          />
          <Route
            path="/shop-dots/update-users"
            element={<ShopDotsUpdateUsers />}
          />
          <Route
            path="/shop-dots/upload-dots"
            element={<ShopDotsUpdateDots />}
          />
          <Route
            path="/shop-dots/:id"
            element={<ShopDotsDetailPage />}
          />
          <Route
            path="/distributions"
            element={<DistributionPage />}
          />
          <Route
            path="/distributions/:id"
            element={<DistributionsDetailPage />}
          />
          <Route
            path="/bonuses_statistics"
            element={<BonusesStatisticsPage />}
          />
          <Route
            path="/bonuses_statistics/:id"
            element={<BonusStatisticsDetailInfo />}
          />
          <Route
            path="/product"
            element={<ProductsPage />}
          />
          <Route
            path="/category"
            element={<CategoryPage />}
          />
          <Route
            path="/partner"
            element={<PartnerPage />}
          />
          <Route
            path="/product/:id"
            element={<ProductDetailPage />}
          />
          <Route path="/content">
            <Route
              path="banner"
              element={<BannersPage />}
            />
            <Route
              path="banner/:id"
              element={<BannerDetailPage />}
            />
            <Route
              path="bannertypes"
              element={<BannerTypePage />}
            />
            <Route
              path="brands/:app_type"
              element={<BrandsPage />}
            />
            <Route
              path="brands/:app_type/:id"
              element={<BrandsDetailPage />}
            />
            <Route
              path="stories"
              element={<StoriesPage />}
            />
            <Route
              path="stories/:id"
              element={<StoriesDetailPage />}
            />
          </Route>
          <Route path="/promo">
            <Route
              path="mechanic"
              element={<MechanicPage />}
            />
            <Route
              path="mechanic/:id"
              element={<MechanicDetailPage />}
            />
            <Route
              path="b2b"
              element={<PromoB2BPage />}
            />
            <Route
              path="b2b/:id"
              element={<PromoB2BDetailPage />}
            />
            <Route
              path="prizes"
              element={<PrizesPage />}
            />
            <Route
              path="prizes/:id"
              element={<PrizesDetailPage />}
            />
            <Route
              path="reportPromo"
              element={<ReportPromoPage />}
            />
            <Route
              path="competitions-b2b"
              element={<CompetitonsB2BPage />}
            />
            <Route
              path="competitions-b2b/:id"
              element={<CompetitionB2BDetailPage />}
            />
            <Route
              path="competitions-b2b/:id/salePoint/:ttId"
              element={<CompetitionSalePointDetails />}
            />
            <Route
              path="competitions-b2cr"
              element={<CompetitonsB2CRPage />}
            />
            <Route
              path="competitions-b2cr/:id"
              element={<CompetitionB2CRDetailPage />}
            />
            <Route
              path="competitions-b2cr/:id/salePoint/:ttId"
              element={<CompetitionSalePointDetails />}
            />
            <Route
              path="prize_places"
              element={<PrizePlacesPage />}
            />
            <Route
              path="prize_places/:id"
              element={<PrizePlacePage />}
            />
          </Route>
          <Route path="/settings">
            <Route
              path="send-OTP"
              element={<SendOtpPage />}
            />
            <Route
              path="countries"
              element={<CountriesPage />}
            />
            <Route
              path="cities"
              element={<CitiesPage />}
            />
            <Route
              path="finance-operations"
              element={<FinanceOperationsPage />}
            />
            <Route
              path="finance-operations/:id"
              element={<FinanceOperationsDetailPage />}
            />
          </Route>
          <Route path="/downloads">
            <Route
              path="shop-dots"
              element={<DownloadsShopDotsPage />}
            />
            <Route
              path="bonuses"
              element={<DownloadsBonusesPage />}
            />
            <Route
              path="tables-code"
              element={<DownloadsTablesCodePage />}
            />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
